import React, { Component } from 'react'
import './TechSkill.css'

export default class TechSkill extends Component {
    render() {
        return (
            <div className='container text-center'>
                <p className="h4">
                    <b className="text-salmon h3">STACK</b> I’m familiar with technologies such as <b className="text-salmon h3">JavaScript, React, HTML, CSS, Bootstrap</b>, Styled-Component, Web design, PhotoShop, Figma... , Web design, PhotoShop, Figma...<a href="https://github.com/Alicerichardson28" target="_blank"><u className="text-dark link">SEE MY GITHUB</u></a>
                </p>
            </div>
        )
    }
}
